import React, { useEffect, useState } from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from '../../../../../components/icon/iconfont'
import { useHistory } from 'react-router-dom'

export const CartCountIcon = props => {
    useStyles(classes)
    const {cartCount = 0, href} = props
	const history = useHistory()

    return <span className={classes.CartIcon}>
        <Iconfont onClick={evt => {
            if(href){
                window.location.href = href
            } else {
                history.push('/cart')
            }
        }}>
            &#xe78e;
            {cartCount ? <span className={classes.CartCount}>{cartCount}</span> : <React.Fragment></React.Fragment>}
        </Iconfont>
    </span>
}